import { Component, OnInit } from "@angular/core";
import { Router } from '@angular/router';
import { STORAGE } from "src/app/constant/storages";
import { AppService } from 'src/app/services/app.service';
import { _deleteStorage, _getStorage, _setStorage } from "src/app/utils/local-storage";

@Component({
  selector: "app-select-no-taxinvoice",
  templateUrl: "./select-no-taxinvoice.component.html",
  styleUrls: ["./select-no-taxinvoice.component.scss"],
})
export class SelectNoTaxinvoiceComponent implements OnInit {
  datalist = [];
  showtable = false;
  constructor(public router: Router,public appService: AppService) {}

  ngOnInit() {}

  ionViewDidEnter() {
    this.appService.setActive(2);
    this.datalist = _getStorage(STORAGE.DATA_SELECT_NO_TAXINVOICE)
    console.log("this.datalist========: ",this.datalist)
    if (this.datalist.length <= 0) {
      this.showtable = true;
    }
  }
  checkbranch(data: any) {
    if (data.buyer_type === "0") {
      return "-";
    } else if (data.buyer_type === "1") {
      if (data.buyer_main_branch_no === "00000") {
        return "สำนักงานใหญ่";
      } else {
        return data.buyer_branch_no;
      }
    } else if (data.buyer_type === "2") {
      return "-";
    }else if(data.buyer_type === "3"){
return "-"
    }
  }
  checkaddress(item) {
    if (item.type_addr === "1") {
      return item.addr_info;
    }else if(item.type_addr === "2"){
      return item.addr_infoEN;

    }
  }

  gotoeditnotaxinvoice(item){
    _setStorage(STORAGE.DATA_EDIT_NO__TAXINVOICE,item)
    this.router.navigate(["/edit-no-taxinvoice"], {
      queryParams: { noName: "no_tax", selectedIndex: "4" },
    });

  }
  gotochecknotaxinvoice(item){
    _setStorage(STORAGE.DATA_ADD_NO__TAXINVOICE,item)
    this.router.navigate(["/check-no-taxinvoice"], {
      queryParams: { noName: "no_tax", selectedIndex: "4" },
    });

  }
  gotoAddNotaxinvoice(){
    this.router.navigate(["/add-no-taxinvoice"], {
      queryParams: { noName: "no_tax", selectedIndex: "4" },
    });
  }
  backsearchNotaxinvoice(){
    this.router.navigate(["/no-tax-invoice"], {
      queryParams: { noName: "no_tax", selectedIndex: "4" },
    });
  }
}
